import PropTypes from 'prop-types';

export const userTypeShape = PropTypes.oneOf(['mobile', 'fttb', 'convergent', '']);
